// Calculate dosage for weight loss formula
export function calculateWeightDosage(answers) {
  // 薏苡仁 (1-2g) - 针对水肿
  let yiyiren = 1;
  if (answers.mainIssue?.includes('edema')) {
    if (answers.edemaTime === 'allday') {
      yiyiren = 2;
    } else {
      yiyiren = 1.5;
    }
  }

  // 扁豆花 (1-2g) - 针对脾虚（疲劳、便溏）
  let biandouhua = 1;
  const hasSpleen = answers.mainIssue?.includes('fatigue') || 
                    answers.constitution?.includes('loose_stool') ||
                    answers.constitution?.includes('cold_limbs');
  
  if (hasSpleen) {
    const spleenCount = [
      answers.mainIssue?.includes('fatigue'),
      answers.constitution?.includes('loose_stool'),
      answers.constitution?.includes('cold_limbs')
    ].filter(Boolean).length;
    
    if (spleenCount >= 2) {
      biandouhua = 2;
    } else {
      biandouhua = 1.5;
    }
  }

  // 荷叶 (1-2g) - 针对食欲旺盛、油腻
  let heye = 1;
  if (answers.mainIssue?.includes('appetite')) {
    if (answers.appetiteType === 'sweet_oily') {
      heye = 2;
    } else {
      heye = 1.5;
    }
  } else if (answers.dietHabits?.includes('heavy_taste')) {
    heye = 1.5;
  }

  // 计算总剂量等级
  const total = yiyiren + biandouhua + heye;
  let level;
  if (total <= 3.5) level = 'light';
  else if (total <= 4.5) level = 'medium';
  else level = 'heavy';

  return {
    yiyiren,
    biandouhua,
    heye,
    level,
    total
  };
}

// Calculate BMI
function calculateBMI(answers) {
  if (!answers.demographics?.height || !answers.demographics?.weight) {
    return null;
  }

  // 简化的BMI计算（基于范围中值）
  const heightMap = {
    '<160': 155,
    '160-170': 165,
    '170-180': 175,
    '>180': 185
  };

  const weightMap = {
    '<50': 45,
    '50-60': 55,
    '60-70': 65,
    '70-80': 75,
    '80-90': 85,
    '>90': 95
  };

  const height = heightMap[answers.demographics.height] / 100;
  const weight = weightMap[answers.demographics.weight];

  if (!height || !weight) return null;

  return weight / (height * height);
}

// Determine review status
export function getWeightReviewStatus(answers, dosage) {
  const bmi = calculateBMI(answers);

  // Red flags
  if (answers.safety && !answers.safety.includes('none')) {
    return {
      status: 'red',
      label: 'Professional Review Required',
      message: 'Health risk factors detected, professional review required.'
    };
  }

  if (bmi && bmi < 24) {
    return {
      status: 'red',
      label: 'Professional Review Required',
      message: 'Your BMI is within normal range, consult a professional if weight loss is needed.'
    };
  }

  if (answers.demographics?.age === 'other') {
    return {
      status: 'red',
      label: 'Professional Review Required',
      message: 'Age factor requires professional confirmation.'
    };
  }

  // Yellow flags
  if (bmi && bmi > 35) {
    return {
      status: 'yellow',
      label: 'Priority Review',
      message: 'Severe obesity, priority assessment recommended.'
    };
  }

  if (answers.goal === '>20') {
    return {
      status: 'yellow',
      label: 'Priority Review',
      message: 'Large weight loss goal, phased plan by professional recommended.'
    };
  }

  // Green
  return {
    status: 'green',
    label: 'Auto Approved',
    message: 'Formula generated, proceeding to production.'
  };
}

// Base formula
export const WEIGHT_BASE_FORMULA = [
  { name: 'Poria Mushroom', amount: '3g' },
  { name: 'Hawthorn fruit', amount: '2g' },
  { name: 'Aged tangerine peel', amount: '1g' },
  { name: 'Turmeric', amount: '3g' }
];